import React, { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
// Performance: Resource hints for critical assets
const head = document.head;
// Preconnect to font origins
const preconnectGoogle = document.createElement('link');
preconnectGoogle.rel = 'preconnect';
preconnectGoogle.href = 'https://fonts.googleapis.com';
head.appendChild(preconnectGoogle);
const preconnectGstatic = document.createElement('link');
preconnectGstatic.rel = 'preconnect';
preconnectGstatic.href = 'https://fonts.gstatic.com';
preconnectGstatic.crossOrigin = 'anonymous';
head.appendChild(preconnectGstatic);
// Preconnect to image CDN
const preconnectCDN = document.createElement('link');
preconnectCDN.rel = 'preconnect';
preconnectCDN.href = 'https://cdn.magicpatterns.com';
head.appendChild(preconnectCDN);
// Preload hero image (LCP element)
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.type = 'image/webp';
preloadHero.href = 'https://cdn.magicpatterns.com/uploads/rCNubuYHEVfNusg35qRpRX/20260318_0837_Image_Generation_simple_compose_01km0brbf1f1zrvz1k9zcwrpya_(1)_(1).webp';
head.appendChild(preloadHero);
// Non-blocking font loading (reduced weights: only what's used)
const fontUrl = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Playfair+Display:wght@700;900&display=swap';
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = fontUrl;
fontLink.media = 'print';
fontLink.onload = function () {
  fontLink.media = 'all';
};
head.appendChild(fontLink);
// Fallback for no-JS
const noscriptFont = document.createElement('noscript');
noscriptFont.innerHTML = `<link rel="stylesheet" href="${fontUrl}">`;
head.appendChild(noscriptFont);
// Defer Meta Pixel until idle
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode?.insertBefore(t, s);
  window.fbq('init', '1386852479794885');
  window.fbq('track', 'PageView');
}
if ('requestIdleCallback' in window) {
  ;
  (window as any).requestIdleCallback(initMetaPixel);
} else {
  setTimeout(initMetaPixel, 2000);
}
// Render app
const root = document.getElementById('root');
if (root) {
  createRoot(root).render(<App data-id="element-363" />);
}